export default __webpack_public_path__ + "static/apple-push-31cb4cc00161e633951272fe440a7710.svg";